module.exports = __webpack_public_path__ + "media/images/project/mark-incomplete-53b83bb20753370c867bf4d361dcab68.svg";